import { Form } from 'antd';
import React from 'react';

import { OPENING_CONFIGURATION_TYPE } from 'app/typings/core/admin/experiences/enum/openingConfiguration';

import { ConstantValueInput } from '../../../../Common/ConstantValueInput/ConstantValueInput';
import { TextBlock } from '../../../../Common/TextBlock/TextBlock';
import { TypeSelector } from '../../../../Common/TypeSelector/TypeSelector';
import styles from '../MaxBookingDrawer.module.scss';

import { MaxBookingDailyRows } from './MaxBookingDailyRows';

export const MaxBookingContent: React.FC = () => {
  const form = Form.useFormInstance();

  const typeValue = Form.useWatch('type', form);
  const isToggledValue = Form.useWatch('isToggled', form);

  return (
    <div className={styles.content}>
      <p className={styles.defaultTitle}>Max booking</p>
      <div className={styles.container}>
        <TextBlock
          title="Enable Max Booking"
          subtitle="Define a maximum number of bookings per day for this package"
          switchName={['isToggled']}
          hasBorder
        >
          {isToggledValue && (
            <>
              <TypeSelector name={['type']} />

              {typeValue === OPENING_CONFIGURATION_TYPE.CONSTANT && (
                <ConstantValueInput
                  name={['configuration', 'maxBooking']}
                  label="Max"
                  suffix="bookings per day"
                />
              )}

              {typeValue === OPENING_CONFIGURATION_TYPE.DAILY && (
                <MaxBookingDailyRows />
              )}
            </>
          )}
        </TextBlock>
      </div>
    </div>
  );
};
